import Fuse from 'fuse.js';

export const findClosestMatch = (target, list) => {
  const options = {
    includeScore: true,
    threshold: 0.4,
  };

  const fuse = new Fuse(
    list.map(str => str.replace(/[_-]/g, ' ')),
    options,
  );
  const matches = fuse.search(target);

  return matches.length > 0 ? matches[0].item : null;
};

export const findClosestMatchFromObject = (obj = {}, fuseOptions = {}) => {
  const options = {
    includeScore: true,
    threshold: 0.2,
    minMatchCharLength: 3,
    keys: ['value'],
    ...fuseOptions,
  };

  const normalizeString = str => str.replace(/[_-]/g, ' ');
  // Convert the object into an array of key-value pairs
  const list = Object.entries(obj).map(([key, value]) => ({
    key,
    value: normalizeString(value), // Normalize the value
  }));

  // Create a Fuse instance using the `value` property for searching
  const fuse = new Fuse(list, options);

  return (target = '') => {
    // search for exact match on the options keys
    const exactMatch = list.find(item => options.keys.some(key => item[key] === target));
    if (exactMatch) {
      return exactMatch.key;
    }

    const exactMatchNoSpaces = list.find(item =>
      options.keys.some(key => normalizeString(item[key]) === normalizeString(target)),
    );
    if (exactMatchNoSpaces) {
      return exactMatchNoSpaces.key;
    }

    const matches = fuse.search(normalizeString(target));
    return matches.length > 0 ? matches[0].item.key : target;
  };
};
